export type PromotionsState = {
  id: string;
  promotionName: string;
  isApplicable: boolean;
  occupancyRule?: OccupancyRule;
  ageRule?: AgeRule;
  periodsRule?: PeriodsRule;
  voyagersClubRule?: VoyagersClubRule;
};

export interface OccupancyRule {
  minAdults?: number;
  minMinors?: number;
  minInfants?: number;
  maxAdults?: number;
  maxMinors?: number;
  maxInfants?: number;
  warningTitleOccupancy?: RichText;
  warningDescriptionOccupancy?: RichText;
  closesOnXOccupancy?: boolean;
  disableAutoclosingOccupancy?: boolean;
  closingTimeOccupancy?: number;
  isApplicable: boolean;
}

export interface AgeRule {
  adultAgeRule?: string;
  adultAge?: number[];
  minorAgeRule?: string;
  minorAge?: number[];
  infantAgeRule?: string;
  infantAge?: number[];
  warningTitleAge?: RichText;
  warningDescriptionAge?: RichText;
  closesOnXAge?: boolean;
  disableAutoclosingAge?: boolean;
  closingTimeAge?: number;
  isApplicable: boolean;
}

export interface PeriodsRule {
  periodLabel?: string;
  startDate?: string;
  endDate?: string;
  warningTitlePeriod?: RichText;
  warningDescriptionPeriod?: RichText;
  closesOnXPeriod?: boolean;
  disableAutoclosingPeriod?: boolean;
  closingTimePeriod?: number;
  isApplicable: boolean;
}

export interface VoyagersClubRule {
  warningTitleVC?: RichText;
  warningDescriptionVC?: RichText;
  closesOnXVC?: boolean;
  disableAutoclosingVC?: boolean;
  closingTimeVC?: number;
  isApplicable: boolean;
}

interface RichText {
  plaintext?: string;
  html?: string;
}

export enum AgeRuleType {
  UNDER = 'under',
  OVER = 'over',
  RANGE = 'range',
}

export type PromotionsPropsResponse = {
  id: string;
  promotionName: string | null;
  minimumOccupancyRule: string | null;
  maximumOccupancyRule: string | null;
  adultAgeRule: string | null;
  adultAge: string[] | null;
  adultRangeStart: string | null;
  adultRangeEnd: string | null;
  minorAgeRule: string | null;
  minorAge: string[] | null;
  minorRangeStart: string | null;
  minorRangeEnd: string | null;
  juniorAgeRule: string | null;
  juniorAge: string[] | null;
  juniorRangeStart: string | null;
  juniorRangeEnd: string | null;
  periodLabel: string | null;
  startDate: string | null;
  endDate: string | null;
  warningTitleOccupancy: RichText | null;
  warningDescriptionOccupancy: RichText | null;
  closesOnXOccupancy: boolean;
  disableAutoclosingOccupancy: boolean;
  closingTimeOccupancy: number;
  warningTitleAge: RichText | null;
  warningDescriptionAge: RichText | null;
  closesOnXAge: boolean;
  disableAutoclosingAge: boolean;
  closingTimeAge: number;
  warningTitlePeriod: RichText | null;
  warningDescriptionPeriod: RichText | null;
  closesOnXPeriod: boolean;
  disableAutoclosingPeriod: boolean;
  closingTimePeriod: number;
  isVoyagersClubPromotion: boolean;
  warningTitleVC?: RichText;
  warningDescriptionVC?: RichText | null;
  closesOnXVC: boolean;
  disableAutoclosingVC: boolean;
  closingTimeVC: number;
};
